"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotoUploadRequest = void 0;
var PhotoUploadRequest = /** @class */ (function () {
    function PhotoUploadRequest() {
    }
    return PhotoUploadRequest;
}());
exports.PhotoUploadRequest = PhotoUploadRequest;
;
//# sourceMappingURL=photoUpload.request.js.map